import { atom } from 'jotai';
import { CREATE_NEW_SPI_CONFIG } from '@src/utils/kpi';

const editModeAtom = atom(false);
const selectedKpiThresholdsAtom = atom(CREATE_NEW_SPI_CONFIG as any);

export { editModeAtom, selectedKpiThresholdsAtom };
